import type { TableContext } from './table.types'

import { createContext } from '../utils'

const [TableProvider, useTableContext] = createContext<TableContext>({ isOptional: true })

export { TableProvider, useTableContext }
